import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-blue-950 via-blue-900 to-slate-900">
      <div className="text-center space-y-6 animate-fade-in">
        {/* SF Logo - Purple background with white text */}
        <div className="mx-auto w-40 h-40 bg-gradient-to-br from-primary to-primary/90 rounded-3xl flex items-center justify-center shadow-2xl shadow-primary/30 transform hover:scale-105 transition-transform duration-300">
          <span className="text-7xl font-bold text-white">SF</span>
        </div>
        
        {/* App Name */}
        <h1 className="text-4xl font-bold text-white tracking-tight">
          StudyFlow
        </h1>
        
        {/* Tagline - Clear white text on dark background */}
        <p className="text-lg text-white font-medium">
          your intelligent study companion
        </p>
        
        {/* Loading Animation */}
        <div className="flex items-center justify-center space-x-2 pt-4">
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-primary rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </div>
    </div>
  );
};

export default LoadingScreen;
